import React from 'react';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { translationClasses } from 'src/shared/TranslationClasses';
import { VideoAsset } from '@ahc-digital/component-library';
import { CreateVideoAssetModel } from './C16VideoAsset.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C16VideoAssetProps = RenderingProps<C16VideoAssetFields, C16VideoAssetParams>;
export type C16VideoAssetParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
export interface C16VideoAssetFields {
  VideoID?: Field<string>;
  Caption?: RichTextField;
}

export const Default = (props?: C16VideoAssetProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <VideoAsset
      {...CreateVideoAssetModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
